import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BsModalRef, BsModalService, ModalModule } from 'ngx-bootstrap/modal';
import { ModalService } from '@shared/modules/modal/services/modal.service';
import {
  ModalDeleteConfirmationComponent
} from './components/modal-delete-confirmation/modal-delete-confirmation.component';
import { ButtonsModule } from '@shared/modules/buttons/buttons.module';
import {
  ModalExportConfirmationComponent
} from '@shared/modules/modal/components/modal-export-confirmation/modal-export-confirmation.component';
import {
  ModalCancelConfirmationComponent
} from '@shared/modules/modal/components/modal-cancel-confirmation/modal-cancel-confirmation.component';
import {
  ModalSimpleConfirmationComponent
} from '@shared/modules/modal/components/modal-simple-confirmation/modal-simple-confirmation.component';
import {
  ModalReportDownloadComponent
} from '@shared/modules/modal/components/modal-report-download/modal-report-download.component';
import { SharedModule } from '@shared/shared.module';

@NgModule({
  declarations: [
    ModalDeleteConfirmationComponent,
    ModalExportConfirmationComponent,
    ModalCancelConfirmationComponent,
    ModalSimpleConfirmationComponent,
    ModalReportDownloadComponent,
  ],
  imports: [
    CommonModule,
    ModalModule.forRoot(),
    ButtonsModule,
    SharedModule
  ],
  providers: [
    BsModalService,
    BsModalRef,
    ModalService
  ]
})
export class AppModalModule {
}
